module.exports = __webpack_public_path__ + "static/media/trana.6d1e84aa.jpg";